document.addEventListener("DOMContentLoaded", () => {
  if (customElements.get("p-sale-bundle-swiper")) return;

  class PSaleBundleSwiper extends HTMLElement {
    constructor() {
      super();
      this.$this = $(this);
      this.productInfo = {};
      this.selectedProduct = {};
      this.isBuyingNow = false;
      this.childSwiperInstances = [];
      this.discountRules = this.$this.data("discount-rules");
      this.selectionMode = this.$this.data("selection-mode") || "single";
      this.sameProductQuantityCountsTowardDiscount =
        this.$this.data("same-product-quantity-counts-toward-discount") === true;
      this.childPcEnableSwiper = this.$this.data("child-pc-enable-swiper");
      this.childMbEnableSwiper = this.$this.data("child-mb-enable-swiper");
      this.childPcSlides = this.$this.data("child-pc-slides");
      this.childMbSlides = this.$this.data("child-mb-slides");
      this.childPcGap = this.$this.data("child-pc-gap");
      this.childMbGap = this.$this.data("child-mb-gap");
      this.childEnableSlidesOffset = this.$this.data("child-slides-offset");
      this.childSlidesOffsets = this.$this.data("child-slides-offsets");
      this.childShowPagination = this.$this.data("child-show-pagination");
      this.childShowNavigation = this.$this.data("child-show-navigation");
      this.$groupSwiperContainer = this.$this.find(".p-sale-bundle-swiper-groups-container");
      this.$groupNamesWrapper = this.$this.find(".p-sale-bundle-swiper-groups-names-wrapper");
      this.$variantsSelector = this.$this.find(".p-variant-selector");

      this.handleGroupChange = this.handleGroupChange.bind(this);
      this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
      this.handleQuantityClick = this.handleQuantityClick.bind(this);
      this.handleQuantityChange = this.handleQuantityChange.bind(this);
      this.handleBuyNowClick = this.handleBuyNowClick.bind(this);
    }

    connectedCallback() {
      this.initGroupSwiper();
      this.initChildSwiper();
      this.initProductInfo();
      this.initCheckboxEvent();
      this.initQuantityEvent();
      this.initBuyNowEvent();
      this.initVariantSelector();
      let resizeTimer = null;
      const self = this;
      let lastWidth = window.innerWidth;
      $(window).on("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          const currentWidth = window.innerWidth;
          if (currentWidth === lastWidth) return;
          self.rebuildSwipers();
          lastWidth = currentWidth;
        }, 200);
      });
    }

    disconnectedCallback() {
      this.$variantsSelector.off(".pSaleBundleVariantSelector");
      this.removeEventListener("click", this.handleCheckboxClick);
      this.removeEventListener("click", this.handleQuantityClick);
      this.removeEventListener("change", this.handleQuantityChange);
      this.removeEventListener("click", this.handleBuyNowClick);
      this.destroySwipers();
    }

    initGroupSwiper() {
      if (this.$groupNamesWrapper.length > 0 && this.$groupSwiperContainer.length > 0) {
        const params = {
          slidesPerView: 1,
          noSwipingClass: "p-sale-bundle-swiper-group-no-swiping",
          allowTouchMove: true,
          spaceBetween: 10,
        };
        this.groupSwiperInstance = new Swiper(this.$groupSwiperContainer[0], params);
        this.initGroupSwiperNameEvent();
      }
    }

    initGroupSwiperNameEvent() {
      if (this.$groupNamesWrapper.length > 0 && this.groupSwiperInstance) {
        const self = this;
        this.handleGroupChange(0);
        this.$groupNamesWrapper.on("click", ".p-sale-bundle-swiper-group-name", function () {
          const index = $(this).data("index");
          self.handleGroupChange(index);
        });
      }
    }

    initChildSwiper() {
      const enableSwiper = window.innerWidth > 850 ? this.childPcEnableSwiper : this.childMbEnableSwiper;
      const $container = this.$this.find(".p-sale-bundle-swiper-children-container");
      const $wrapper = $container.find(".p-sale-bundle-swiper-children-wrapper");
      const $item = $wrapper.find(".p-sale-bundle-swiper-children-product-item");
      if (enableSwiper) {
        $container.addClass("swiper-container");
        $wrapper.addClass("swiper-wrapper");
        $item.addClass("swiper-slide");
        $container.each((i, childrenContainer) => {
          const params =
            window.innerWidth > 850
              ? {
                  slidesPerView: this.childPcSlides,
                  spaceBetween: this.childPcGap,
                  allowTouchMove: this.childEnableSlidesOffset ? true : this.childPcSlides < $item.length,
                }
              : {
                  slidesPerView: this.childMbSlides,
                  spaceBetween: this.childMbGap,
                  allowTouchMove: this.childEnableSlidesOffset ? true : this.childMbSlides < $item.length,
                };
          if (this.childEnableSlidesOffset || window.innerWidth < 850) {
            const offsetValue = this.getChildSlidesOffset();
            params.slidesOffsetBefore = offsetValue;
            if (window.innerWidth < 850) {
              params.slidesOffsetAfter = offsetValue;
            }
            params.watchOverflow = false;
          }
          if (this.childShowPagination && params.allowTouchMove) {
            params.pagination = {
              el: $(childrenContainer).parent().find(".swiper-pagination")[0],
              clickable: true,
              type: "bullets",
            };
          }
          if (this.childShowNavigation && params.allowTouchMove) {
            const $buttons = $(childrenContainer).parent().find(".p-sale-bundle-swiper-buttons-container");
            params.navigation = {
              nextEl: $buttons.find(".swiper-button-next")[0],
              prevEl: $buttons.find(".swiper-button-prev")[0],
            };
          }
          this.childSwiperInstances[i] = new Swiper(childrenContainer, params);
        });
      } else {
        $container.removeClass("swiper-container");
        $wrapper.removeClass("swiper-wrapper");
        $item.removeClass("swiper-slide");
      }
    }

    initProductInfo() {
      this.getGroups().each((_, group) => {
        try {
          const $group = $(group);
          const groupName = this.getGroupName($group);
          this.productInfo[groupName] = {};
          const $childProduct = $group.find(".p-sale-product-card");
          $childProduct.each((_, product) => {
            const productInfo = $(product).data("product-info");
            if (productInfo?.product) {
              this.productInfo[groupName][productInfo.product] = productInfo;
            }
          });
        } catch (e) {
          console.error(">>> p-sale-bundle-swiper", e);
        }
      });
      this.updatePrice();
      this.updateButtons();
    }

    initCheckboxEvent() {
      this.removeEventListener("click", this.handleCheckboxClick);
      this.addEventListener("click", this.handleCheckboxClick);
    }

    handleCheckboxClick(event) {
      if (this.selectionMode !== "single") return;

      const $checkbox = $(event.target).closest(".p-sale-bundle-swiper-checkbox");
      if ($checkbox.length === 0 || $checkbox.prop("disabled")) return;

      const $productCard = $checkbox.closest(".p-sale-product-card");
      const context = this.getProductContext($productCard);
      if (!context || context.variant.available === false) return;

      const key = this.parseKey(context);
      this.toggleProductSelect(key, context.variant, $checkbox);
      this.updatePrice();
      this.updateButtons();
    }

    initQuantityEvent() {
      if (this.selectionMode !== "multiple") return;

      this.removeEventListener("click", this.handleQuantityClick);
      this.removeEventListener("change", this.handleQuantityChange);
      this.addEventListener("click", this.handleQuantityClick);
      this.addEventListener("change", this.handleQuantityChange);
    }

    handleQuantityClick(event) {
      const $target = $(event.target);
      const $addButton = $target.closest("[data-bundle-add-product]");
      const $increaseButton = $target.closest("[data-quantity-increase]");
      const $decreaseButton = $target.closest("[data-quantity-decrease]");

      if ($addButton.length === 0 && $increaseButton.length === 0 && $decreaseButton.length === 0) return;

      const $card = $target.closest(".p-sale-product-card");
      const context = this.getProductContext($card);
      if (!context || context.variant.available === false) return;

      event.preventDefault();
      const key = this.parseKey(context);
      const currentQuantity = this.selectedProduct[key]?.quantity || 0;
      let nextQuantity = currentQuantity;

      if ($addButton.length > 0) nextQuantity = 1;
      if ($increaseButton.length > 0) nextQuantity = currentQuantity + 1;
      if ($decreaseButton.length > 0) nextQuantity = Math.max(0, currentQuantity - 1);

      this.setProductQuantity($card, nextQuantity);
    }

    handleQuantityChange(event) {
      const $input = $(event.target).closest("[data-quantity-input]");
      if ($input.length === 0) return;

      const parsedQuantity = Number.parseInt($input.val(), 10);
      const quantity = Number.isFinite(parsedQuantity) ? Math.max(0, parsedQuantity) : 0;
      this.setProductQuantity($input.closest(".p-sale-product-card"), quantity);
    }

    setProductQuantity($card, quantity) {
      const context = this.getProductContext($card);
      if (!context) return;

      const normalizedQuantity = Math.max(0, Math.floor(Number(quantity) || 0));
      const nextQuantity = context.variant.available === false ? 0 : normalizedQuantity;
      const key = this.parseKey(context);

      this.removeSelectedProduct(context.groupName, context.product);
      if (nextQuantity > 0) {
        this.selectedProduct[key] = {
          ...context.variant,
          quantity: nextQuantity,
        };
      }

      this.updateQuantityUI($card, nextQuantity);
      this.updatePrice();
      this.updateButtons();
    }

    updateQuantityUI($card, quantity) {
      const isSelected = quantity > 0;
      $card.find("[data-bundle-add-product]").prop("hidden", isSelected);
      $card.find("[data-quantity-selector]").prop("hidden", !isSelected);
      $card.find("[data-quantity-input]").val(isSelected ? quantity : 1);
    }

    removeSelectedProduct(groupName, product) {
      Object.keys(this.selectedProduct).forEach((key) => {
        const [selectedGroupName, selectedProduct] = this.parseKey(key);
        if (selectedGroupName === String(groupName) && selectedProduct === String(product)) {
          delete this.selectedProduct[key];
        }
      });
    }

    initBuyNowEvent() {
      if (this.selectionMode !== "multiple") return;

      this.removeEventListener("click", this.handleBuyNowClick);
      this.addEventListener("click", this.handleBuyNowClick);
    }

    async handleBuyNowClick(event) {
      const $button = $(event.target).closest(".p-sale-bundle-swiper-buy-now");
      if ($button.length === 0 || $button.prop("disabled") || this.isBuyingNow) return;

      const groupName = this.getGroupName(this.getGroup($button));
      const products = this.getSelectedProductsByGroup()[groupName] || [];
      if (products.length === 0) return;

      event.preventDefault();
      this.isBuyingNow = true;
      this.updateButtons();
      $button.addClass("is-loading").attr("aria-busy", "true");

      try {
        const root = window.Shopify?.routes?.root || "/";
        const clearResponse = await fetch(`${root}cart/clear.js`, { method: "POST" });
        if (!clearResponse.ok) throw new Error(`Failed to clear cart (${clearResponse.status})`);

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: products.map((product) => ({
              id: Number(product.variantId),
              quantity: product.quantity,
            })),
          }),
        });
        if (!addResponse.ok) {
          const error = await addResponse.json().catch(() => ({}));
          throw new Error(error.description || `Failed to add products (${addResponse.status})`);
        }

        const cartResponse = await fetch(`${root}cart.js`);
        if (!cartResponse.ok) throw new Error(`Failed to get cart (${cartResponse.status})`);

        const cart = await cartResponse.json();
        if (cart && window.CartApi && typeof window.CartApi.notifyTimberCartUpdated === "function") {
          await window.CartApi.notifyTimberCartUpdated(cart, {
            source: "timber_checkout_url",
          });
        }

        window.location.href = "/checkout";
      } catch (error) {
        console.error("加购失败，请重试", error);
      } finally {
        this.isBuyingNow = false;
        $button.removeClass("is-loading").removeAttr("aria-busy");
        this.updateButtons();
      }
    }

    initVariantSelector() {
      if (this.$variantsSelector.length === 0) return;

      const eventName = "change.pSaleBundleVariantSelector";

      this.$variantsSelector.off(eventName, "select");
      this.$variantsSelector.on(eventName, "select", (event) => {
        const select = event.currentTarget;
        const selectedOption = select.options[select.selectedIndex];
        const variantData = selectedOption?.getAttribute("data-variant");

        if (!variantData) return;

        let variant;
        try {
          variant = JSON.parse(variantData);
        } catch (error) {
          console.error("Invalid variant data in p-sale-product-card", error);
          return;
        }

        const $selector = $(select).closest(".p-variant-selector");
        const $card = $selector.closest(".p-sale-product-card");
        if ($card.length === 0) return;

        const productInfo = $card.data("product-info") || {};
        const previousVariant = productInfo.variants?.[0] || {};
        const $group = this.getGroup($card);
        const groupName = this.getGroupName($group);
        const previousProductHandle = productInfo.product;
        const productHandle = variant.handle || previousProductHandle;
        const price = Number(variant.price) || 0;
        const compareAtPrice = Number(variant.compareAtPrice) || 0;
        const variantId = Number(variant.id);
        const available = variant.available !== false;

        $selector.find(".p-variant-selector-value").text(variant.title || selectedOption.textContent.trim());

        const formatMoney = (amount) => {
          if (window.theme?.Currency?.formatMoney) {
            return window.theme.Currency.formatMoney(amount, window.theme.strings?.moneyFormat);
          }

          return `$${(amount / 100).toFixed(2)}`;
        };
        const updatePrice = ($price, formattedPrice, amount) => {
          if ($price.length === 0) return;

          const priceText = formattedPrice || formatMoney(amount);
          const priceParts = priceText.match(/^(.*?)([.,]\d{2})$/);

          $price.attr("content", (amount / 100).toFixed(2));
          $price.find(".price-int").text(priceParts ? priceParts[1] : priceText);
          $price.find(".price-dec").text(priceParts ? priceParts[2] : "");
        };

        const $priceBox = $card.find(".product-price-box").first();
        updatePrice($priceBox.find(".on-sale").first(), variant.formattedPrice, price);
        this.updateProductImage($card, variant.featured_image_url);

        const $compareAtPrice = $priceBox.find(".compare-at").first();
        const hasCompareAtPrice = compareAtPrice > price;
        $compareAtPrice
          .text(hasCompareAtPrice ? variant.formattedCompareAtPrice || formatMoney(compareAtPrice) : "")
          .prop("hidden", !hasCompareAtPrice);

        const $discountContainer = $card.find(".p-sale-product-card-discount-container").first();
        const discountContent = variant.discountContent || "";
        $discountContainer.find(".p-sale-product-card-discount-content").html(discountContent);
        $discountContainer.prop("hidden", !discountContent);

        const updatedVariant = {
          variantId,
          price,
          compareAtPrice: compareAtPrice || price,
          available,
        };
        const updatedProductInfo = {
          ...productInfo,
          product: productHandle,
          variants: [updatedVariant],
        };

        $card.attr("data-product-info", JSON.stringify(updatedProductInfo));
        $card.attr("data-product-handle", productHandle);
        $card.data("product-info", updatedProductInfo);

        if (groupName && previousProductHandle && this.productInfo[groupName]) {
          delete this.productInfo[groupName][previousProductHandle];
        }
        if (groupName && productHandle && this.productInfo[groupName]) {
          this.productInfo[groupName][productHandle] = updatedProductInfo;
        }

        const $checkbox = $card.find(".p-sale-bundle-swiper-checkbox").first();
        const $addButton = $card.find("[data-bundle-add-product]").first();
        $checkbox.prop("disabled", !available);
        $addButton.prop("disabled", !available);

        const previousKey = this.parseKey({
          groupName,
          product: previousProductHandle,
          variantId: previousVariant.variantId,
        });
        const previousSelection = this.selectedProduct[previousKey];
        if (previousSelection) {
          delete this.selectedProduct[previousKey];

          if (available) {
            const nextKey = this.parseKey({ groupName, product: productHandle, variantId });
            const quantity = previousSelection.quantity || 1;
            this.selectedProduct[nextKey] = { ...updatedVariant, quantity };
            if (this.selectionMode === "multiple") this.updateQuantityUI($card, quantity);
          } else {
            $checkbox.removeClass("is-active").attr("aria-checked", "false");
            if (this.selectionMode === "multiple") this.updateQuantityUI($card, 0);
          }
        }

        this.updatePrice();
        this.updateButtons();
      });
    }

    updateProductImage($card, imageUrl) {
      if (!imageUrl) return;

      const $productImage = $card.find(".product-image").first();
      if ($productImage.length === 0) return;

      const $img = $productImage.find("img").first();
      const $sources = $productImage.find("source");

      $img.attr({
        src: imageUrl,
        srcset: imageUrl,
      });

      $sources.attr({
        srcset: imageUrl,
      });
    }

    toggleProductSelect(key, variant, $checkbox) {
      if (this.selectedProduct[key]) {
        delete this.selectedProduct[key];
        $checkbox.removeClass("is-active");
        $checkbox.attr("aria-checked", "false");
      } else {
        $checkbox.addClass("is-active");
        $checkbox.attr("aria-checked", "true");
        this.selectedProduct[key] = { ...variant, quantity: 1 };
      }
    }

    updatePrice() {
      const result = {};
      Object.keys(this.selectedProduct).forEach((key) => {
        const variant = this.selectedProduct[key];
        const [groupName, product, variantId] = this.parseKey(key);
        if (!result[groupName]) {
          result[groupName] = {
            total: 0,
            compare: 0,
            variantId: [],
            count: 0,
          };
        }
        const quantity = Math.max(1, Number(variant.quantity) || 1);
        result[groupName].total += variant.price * quantity;
        result[groupName].compare += variant.compareAtPrice * quantity;
        result[groupName].variantId.push(variantId);
        result[groupName].count += this.sameProductQuantityCountsTowardDiscount ? quantity : 1;
      });
      this.getGroups().each((_, group) => {
        const $group = $(group);
        const groupName = this.getGroupName($group);
        const $priceEl = $group.find(".p-sale-bundle-swiper-price-total");
        const $compareEl = $group.find(".p-sale-bundle-swiper-price-compare-at");
        const $discountEl = $group.find(".p-sale-bundle-swiper-price-discount");
        let total = 0;
        let compare = 0;
        if (result[groupName]) {
          total = result[groupName].total;
          compare = result[groupName].compare;
        }

        const calcTotal = this.getCalculatedPrice(total, result[groupName]?.count);

        const totalFormat = this.formatMoney(calcTotal);
        const compareFormat = this.formatMoney(compare);
        const discount = this.formatMoney(Math.max(0, compare - calcTotal));
        $priceEl.text(totalFormat);
        $compareEl.text(compareFormat);
        $discountEl.text(discount);
      });
    }

    getCalculatedPrice(price, count = 0) {
      const str = this.discountRules;
      if (!str || !count || !price) return price;

      const rules = str
        .split(",")
        .map((rule) => {
          const [qtyPart, discountPart] = rule.split(":");
          if (!qtyPart || !discountPart) return null;

          let min, max;

          if (qtyPart.includes("+")) {
            min = parseInt(qtyPart);
            max = Infinity;
          } else if (qtyPart.includes("-")) {
            const [minStr, maxStr] = qtyPart.split("-");
            min = parseInt(minStr);
            max = parseInt(maxStr);
          } else {
            min = parseInt(qtyPart);
            max = min;
          }

          return {
            min,
            max,
            discount: parseFloat(discountPart),
          };
        })
        .filter(Boolean)
        .sort((a, b) => a.min - b.min);

      let discount = 1;

      for (const rule of rules) {
        if (count >= rule.min && count <= rule.max) {
          discount = rule.discount;
        }
      }

      return Math.round(price * discount);
    }

    updateButtons() {
      const result = this.getSelectedProductsByGroup();
      this.getGroups().each((_, group) => {
        const $group = $(group);
        const groupName = this.getGroupName($group);
        const products = result[groupName] || [];
        const hasSelectedProduct = products.length > 0;
        const isBuyNowDisabled = !hasSelectedProduct || this.isBuyingNow;
        const isAddToCartDisabled = !hasSelectedProduct || this.isBuyingNow;
        const $buyNowButton = $group.find(".p-sale-bundle-swiper-buy-now");
        const $addToCart = $group.find(".p-sale-bundle-swiper-add-to-cart");
        const productData = JSON.stringify(products);

        $buyNowButton.attr("data-id", products.map((product) => product.variantId).join(","));
        $buyNowButton.toggleClass("is-active", hasSelectedProduct);
        $buyNowButton.prop("disabled", isBuyNowDisabled).attr("aria-disabled", String(isBuyNowDisabled));
        $addToCart.toggleClass("is-active", hasSelectedProduct);
        $addToCart.attr("data-products", productData);
        $addToCart
          .find("button")
          .prop("disabled", isAddToCartDisabled)
          .attr("aria-disabled", String(isAddToCartDisabled));
      });
    }

    getSelectedProductsByGroup() {
      const result = {};
      const selectedProductKeys = Object.keys(this.selectedProduct);
      selectedProductKeys.forEach((key) => {
        const [groupName, product, variantId] = this.parseKey(key);
        const variant = this.selectedProduct[key];
        if (variant.available === false || variant.quantity <= 0) return;
        if (!result[groupName]) {
          result[groupName] = [];
        }
        result[groupName].push({
          variantId,
          quantity: Math.max(1, Number(variant.quantity) || 1),
          handle: product,
        });
      });

      return result;
    }

    getGroups() {
      const $groups = this.$this.find(".p-sale-bundle-swiper-group-container");
      if ($groups.length > 0) return $groups;

      return this.$this.find(".p-sale-bundle-swiper-groups-wrapper").first();
    }

    getGroup($element) {
      const $group = $element.closest(".p-sale-bundle-swiper-group-container");
      if ($group.length > 0) return $group;

      return $element.closest(".p-sale-bundle-swiper-groups-wrapper");
    }

    getGroupName($group) {
      return String($group.data("group-name") || "all");
    }

    getProductContext($card) {
      if ($card.length === 0) return null;

      const info = $card.data("product-info") || {};
      const variant = info.variants?.[0];
      if (!info.product || !variant?.variantId) return null;

      return {
        groupName: this.getGroupName(this.getGroup($card)),
        product: info.product,
        variantId: variant.variantId,
        variant,
      };
    }

    formatMoney(amount) {
      if (window.theme?.Currency?.formatMoney) {
        return window.theme.Currency.formatMoney(amount, window.theme.strings?.moneyFormat);
      }

      return `$${(Number(amount || 0) / 100).toFixed(2)}`;
    }

    parseKey(param) {
      if (typeof param === "object") {
        const { groupName, product, variantId } = param;
        return `${groupName}::${product}::${variantId}`;
      } else if (typeof param === "string") {
        const [groupName, product, variantId] = param.split("::");
        return [groupName, product, variantId];
      }
    }

    destroySwipers() {
      if (this.groupSwiperInstance && !this.groupSwiperInstance.destroyed) {
        this.groupSwiperInstance.off("slideChange.fixed");
        this.groupSwiperInstance.destroy(true, true);
        this.groupSwiperInstance = null;
      }
      if (Array.isArray(this.childSwiperInstances) && this.childSwiperInstances.length > 0) {
        this.childSwiperInstances.forEach((instance) => {
          instance.off("slideChange.fixed");
          instance.destroy(true, true);
          instance = null;
        });
        this.childSwiperInstances = [];
      }
    }

    rebuildSwipers() {
      this.destroySwipers();
      this.initGroupSwiper();
      this.initChildSwiper();
    }

    handleGroupChange(index) {
      this.groupSwiperInstance.slideTo(index);

      const $items = this.$groupNamesWrapper.find(".p-sale-bundle-swiper-group-name");
      const $active = $items.removeClass("is-active").eq(index).addClass("is-active");

      const container = this.$groupNamesWrapper.parent()[0]; // container
      const item = $active[0];

      if (!container || !item) return;

      const containerWidth = container.clientWidth;
      const itemLeft = item.offsetLeft;
      const itemWidth = item.offsetWidth;

      const target = itemLeft - containerWidth / 2 + itemWidth / 2;

      const maxScroll = container.scrollWidth - containerWidth;
      const finalScroll = Math.max(0, Math.min(target, maxScroll));

      container.scrollTo({
        left: finalScroll,
        behavior: "smooth",
      });
    }

    getSwiperOffset() {
      const cssOffset = getComputedStyle(document.documentElement)
        .getPropertyValue("--p-common-wrapper-half-padding")
        .trim();
      const el = document.createElement("div");
      el.style.position = "absolute";
      el.style.visibility = "hidden";
      el.style.pointerEvents = "none";
      el.style.width = `${cssOffset}`;

      document.body.appendChild(el);
      const value = el.getBoundingClientRect().width;
      document.body.removeChild(el);

      return value;
    }

    getChildSlidesOffset() {
      const hasCustomOffset =
        this.childEnableSlidesOffset &&
        this.childSlidesOffsets !== undefined &&
        this.childSlidesOffsets !== null &&
        this.childSlidesOffsets !== "";
      const customOffset = Number(this.childSlidesOffsets);

      if (hasCustomOffset && Number.isFinite(customOffset)) {
        return customOffset;
      }

      return this.getSwiperOffset();
    }
  }

  customElements.define("p-sale-bundle-swiper", PSaleBundleSwiper);
});
